/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type BackofficeOrganizationsQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type BackofficeOrganizationsQuery = {
  __typename?: 'Query'
  backofficeOrganizations: Array<{
    __typename?: 'BackofficeOrganization'
    id: string
    name: string
    operatorTenants: Array<string>
    customerTenants: Array<string>
    ridepoolingServiceTenants: Array<string>
  }>
}

export const BackofficeOrganizationsDocument = gql`
    query backofficeOrganizations {
  backofficeOrganizations {
    id
    name
    operatorTenants
    customerTenants
    ridepoolingServiceTenants
  }
}
    `

/**
 * __useBackofficeOrganizationsQuery__
 *
 * To run a query within a React component, call `useBackofficeOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBackofficeOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBackofficeOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBackofficeOrganizationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BackofficeOrganizationsQuery,
    BackofficeOrganizationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BackofficeOrganizationsQuery,
    BackofficeOrganizationsQueryVariables
  >(BackofficeOrganizationsDocument, options)
}
export function useBackofficeOrganizationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BackofficeOrganizationsQuery,
    BackofficeOrganizationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BackofficeOrganizationsQuery,
    BackofficeOrganizationsQueryVariables
  >(BackofficeOrganizationsDocument, options)
}
// @ts-ignore
export function useBackofficeOrganizationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    BackofficeOrganizationsQuery,
    BackofficeOrganizationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  BackofficeOrganizationsQuery,
  BackofficeOrganizationsQueryVariables
>
export function useBackofficeOrganizationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackofficeOrganizationsQuery,
        BackofficeOrganizationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  BackofficeOrganizationsQuery | undefined,
  BackofficeOrganizationsQueryVariables
>
export function useBackofficeOrganizationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        BackofficeOrganizationsQuery,
        BackofficeOrganizationsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    BackofficeOrganizationsQuery,
    BackofficeOrganizationsQueryVariables
  >(BackofficeOrganizationsDocument, options)
}
export type BackofficeOrganizationsQueryHookResult = ReturnType<
  typeof useBackofficeOrganizationsQuery
>
export type BackofficeOrganizationsLazyQueryHookResult = ReturnType<
  typeof useBackofficeOrganizationsLazyQuery
>
export type BackofficeOrganizationsSuspenseQueryHookResult = ReturnType<
  typeof useBackofficeOrganizationsSuspenseQuery
>
export type BackofficeOrganizationsQueryResult = Apollo.QueryResult<
  BackofficeOrganizationsQuery,
  BackofficeOrganizationsQueryVariables
>
